import { yup } from '@guiker/yup-util'

export const imageSchema = yup.object({
  data: yup.string().required(),
})
